import React from 'react';
import StationTag from './components/station-tag';
import EquipTypeTag from './components/equip-type-tag';
// import ActivityTag from './components/activity-tag';
import PriceLabel from './components/price-label';
import { jumpPage, wxInit, myInit } from '../../utils/common';
import './index.less';
import { trackGdp } from '../../utils/gio-report';

const StationItem = (props) => {
  const { station, showDistance, withLine = true, showAddress = false, showAct = true, price = '', distanceLabel = '', className = '', isSharePile = false, from = '', showTab = true } = props;
  // console.log(station, 'station')
  const UA = navigator.userAgent || "";
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

  const onGoDetail = (stationId: number | string) => {
    // 上报埋点
    from === 'heap' && trackGdp('P20180', 'B017', { stationId })
    if (isXPApp) {
      jumpPage(
        isSharePile
          ?
          `xiaopeng://xrn/dynamicPage?launchPage=XPMotors_ReactNativeHomePileStationDetail&stationId=${stationId}`
          :
          `xiaopeng://charging/station/detail?id=${stationId}`
      );
    } else if (isWXApp) {
      wxInit().then(wx =>
        wx.miniProgram.navigateTo({
          url: isSharePile ? `/pages/home-pile-station-detail/index?stationId=${stationId}` : `/charging/pages/station-detail/index?stationId=${stationId}`
        })
      );
    } else if (isMyApp) {
      myInit().then(my =>
        my.navigateTo({
          url: isSharePile ? `/pages/home-pile-station-detail/index?stationId=${stationId}` : `/charging/pages/station-detail/index?stationId=${stationId}`
        })
      );
    } else {
      let env = 'release'
      if (window.location.href.indexOf('static.deploy-test.xiaopeng.com') !== -1) {
        env = 'develop';
      }
      window.location.href = `https://static.xiaopeng.com/apps/charge-web/jump-to-wx-mini.html?page=${isSharePile ? `pages/home-pile-station-detail/index` : `charging/pages/station-detail/index`}&query=stationId%3D${stationId}&version=${env}`;
    }
  };

  return (
    <div
      className={`station-card-wrap ${station?.stationAvailabilityDesc ? 'disabled' : ''} ${className}`}
      key={station?.stationId}
      onClick={() => onGoDetail(station?.stationId)}
    >
      <div className='title-row'>
        <span className='name'>{station?.stationName}</span>
        {
          (showDistance && (!!station?.distance || distanceLabel)) ? (
            <div className='location-info'>
              {!distanceLabel && <img className='location-icon' alt='' src={`https://s.xiaopeng.com/xp-charge/mini/common/navigator-pointer.png`} />}
              <span className='distance'>{distanceLabel}{station?.distance}km</span>
            </div>
          ) : null
        }
      </div>
      {showTab && <StationTag
        disabled={!!station?.stationAvailabilityDesc}
        useInDetail={false}
        stationLabelList={station?.stationLabelList}
        className='station-tag'
      />
      }
      {showAddress && <div className='stationAddress'>{station?.stationAddr || '--'}</div>}
      <div className='pile-info-row'>
        <div className='price-info'>
          <span className='prefix'>￥ </span>
          <span className='num'>{price || station?.stationBillingInfo?.minTotalPrice || '--'}</span>
          <span className='unit'>/度 {
            (station?.stationBillingInfo?.minTotalPrice !== station?.stationBillingInfo?.totalPrice && !price) ? '起' : ''
          }</span>
          {
            [1, 2].includes(station?.stationActivityInfoV5?.activityType)
            &&
            <span className='origin-price'>{station?.stationActivityInfoV5?.activityPriceDesc}</span>
          }
        </div>
        <div className='pile-status'>
          {
            station?.stationEquipOverViewList?.length > 0 && station?.stationEquipOverViewList.map((eItem, eIndex) => (
              <div className='equipTypeList' key={eIndex + eItem?.type}>
                <EquipTypeTag
                  type={eItem?.chargePowerType}
                  name={eItem?.typeName}
                  isDisabled={!!station?.stationAvailabilityDesc}
                />
                <div className='status'>
                  <span className='idle'>
                    {
                      ([1, 2].includes(station?.stationActivityInfoV5?.activityType) && station?.stationEquipOverViewList?.length > 2)
                        ?
                        ''
                        :
                        '闲 '
                    }
                    {eItem?.freeNums}
                  </span>
                  <span className='all'>/{eItem?.nums}</span>
                </div>
              </div>
            ))
          }
        </div>
      </div>
      {/* <ActivityTag
        disabled={!!station?.stationAvailabilityDesc}
        type={station?.stationActivityInfo?.activityType}
        activityPriceDesc={station?.stationActivityInfo?.activityPriceDesc}
        activityAbbr={station?.stationActivityInfo?.activityAbbr}
        className='station-activity-tag'
        showBackUpText={false}
      /> */}
      {
        showAct
        &&
        <PriceLabel
          className='station-activity-tag'
          disabled={!!station?.stationAvailabilityDesc}
          showBackUpText={false}
          labelInfo={station?.stationActivityInfoV5}
        />
      }
      {
        station?.stationAvailabilityDesc ? (
          <div className='error-tip'>{station?.stationAvailabilityDesc}</div>
        ) : null
      }
      {withLine && <div className='devide-bottom-line'></div>}
    </div>
  );
};

export default StationItem;
